<div class="guest-selector" tabindex="-1">
  <div #guest class="guest-wrapper input-group">
      <!-- focusable="false" is used to disable tabbing in IE for SVG -->
    <svg class="icon icon--xs icon--white icon-people" viewBox="0 0 16 15" focusable="false">
      <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/Static/img/icons/shared/personas.svg#UI-Desktop"></use>
    </svg>
    <span id="guestInput" #guestInput tabindex="0" (click)="toggleGuestsSelector(null)" (keyup)="toggleGuestsSelector('open')" (keydown)="onEnter($event)" class="guest-selector__text arrow-down input" [innerHTML]="guestText"></span>
    <label for="guestInput">
      <span [innerHTML]="guestSelector.label"></span>
      <span class="hidden" [innerHTML]="guestSelector.bookingInnerWidgetguestsLabel"></span>
      <span class="hide-on-load">@ViewBag.BookingWidgetLabels.BookingWidgetGuestCountLabel</span>
    </label>
  </div>
  <div class="dropdown__modal" [hidden]="!isOpen">
    <div class="guest-selector__header">
      <label for="guest-selector__room-count" class="guest-selector__header-label">
        <span [innerHTML]="guestSelector.roomCountLabel"></span>: &nbsp;
      </label>
      <div class="custom-select custom-select--inline custom-select--booking-widget-dialog" >
        <select id="guest-selector__room-count" class="guest-selector__room-count" [(ngModel)]="roomCount" (change)="updateRooms()" aria-invalid="false">
          <option value="1" selected="selected">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
        </select>
      </div>
      <span class="error-text" *ngIf="(voucher || redemption) && roomCount > 1">
        <span *ngIf="guestSelector.rewardsNightError && redemption" [innerHTML]="guestSelector.rewardsNightError"></span>
        <span *ngIf="guestSelector.voucherError && voucher" [innerHTML]="guestSelector.voucherError"></span>
      </span>
    </div>
    <div class="guest-selector__body">
      <div class="guest-selector__room-details" *ngFor="let room of guestData.rooms; let i = index;">
        <div class="room-info">
          <div class="room-info__label">
            <span [innerHTML]="guestSelector.roomLabel"></span> {{ i+1 }}:
          </div>
          <div class="input-group-2col">
            <div class="input-group-2col__col">
              <scandic-number-input ariaLabel="adults. Choose the number of adults that will stay in the room." type="adult" (changed)="updateGuestCount($event, i)" [value]="room.Adults" name="room[{{i}}].adults" min="1" max="6"></scandic-number-input>
            </div>
            <div class="input-group-2col__col">
              <scandic-number-input ariaLabel="children. Choose the number of children that will stay in the room." type="child" (changed)="updateGuestCount($event, i)" [value]="room.Child.length" min="0" max="5"></scandic-number-input>
            </div>
          </div>
        </div>
        <div class="guest-selctor__child-info" *ngIf="room && room.Child">
          <div class="child-info" data-js="child-info" *ngFor="let child of room.Child; let j = index;">
            <div class="input-group-2col">
              <div class="input-group-2col__col">
                <label for="room[{{i}}].child[{{j}}].age" class="child-info__label" [innerHTML]="guestSelector.childAgeSelectLabel + ' ' + (j + 1)"></label>
                <div class="custom-select">
                  <select required="" name="room[{{i}}].child[{{j}}].age" id="room[{{i}}].child[{{j}}].age" (change)="updateChildInfo(i, j, 'Age', $event)">
                    <option disabled="" [attr.selected]="child.Age == -1 ? 'selected' : null" style="display: none;" [innerHTML]="guestSelector.childSelectAgeLabel"></option>
                    <option *ngFor="let age of allowedAge" value="{{ age }}" [attr.selected]="child.Age == age ? 'selected' : null">
                      {{ age }}
                      <span [innerHTML]="age != 1 ? guestSelector.childAgePluralLabel : guestSelector.childAgeSingularLabel"></span>
                    </option>
                  </select>
                </div>
                <span class="field-validation-error error-text" *ngIf="child && child.valid === false && (!child.Age || child.Age < 0)" [innerHTML]="guestSelector.childAgeReqdError"></span>
              </div>
              <div class="input-group-2col__col" *ngIf="child && child.Age >= 0">
                <label for="room[{{i}}].child[{{j}}].bed" hidden class="hidden hidden--accessible">Bed type</label>
                <label for="room[{{i}}].child[{{j}}].age" class="child-info__label" [innerHTML]="guestSelector.childSelectBedtypeLabel"></label>
                <div class="custom-select">
                  <select required="" name="room[{{i}}].child[{{j}}].bed" id="room[{{i}}].child[{{j}}].bed" (change)="updateChildInfo(i, j, 'Bed', $event)">
                    <option *ngFor="let bedType of child.availableBedTypes" value="{{bedType.value}}" [selected]="child.Bed == bedType.value">{{bedType.text}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="guest-selector__footer">
      <a class="iconic-item iconic-item--m iconic-item--centeredx close-guest-selector" (click)="toggleGuestsSelector('close', $event)">
        <span class="iconic-item__text" [innerHTML]="guestSelector.doneButtonLabel"></span>
      </a>
    </div>
  </div>
</div>